/** @see: src/errors/app.ts */

export enum ErrorMessage {
  // FatalErrors - Fullpage
  SYSTEM_ERROR = 'SYSTEM_ERROR',
}

export enum ErrorCode {
  ALREADY_EXISTS = 'already-exists',
  UNKNOWN = 'unknown-error',
  LINK_DEAD = 'link-dead',
  FATAL_ERROR = 'FATAL_ERROR',
  FATAL = 'fatal',
  NOT_FOUND = 'not-found',
  PERMISSION_DENIED = 'forbidden',
  IMPLEMENTATION_DEFECT = 'implementation-defect',
  INTERNAL = 'internal',
  INTERNAL_1 = 'INTERNAL',
  INVALID_TENANT_ID = 'invalid-tenant-id',
  INVALID_TENANT_STATE = 'invalid-tenant-state',
  INCOMPLETE_OPERATION = 'incomplete-operation',
  SESSION_EXPIRED = 'session-expired',
  INVALID_SESSION_ID = 'invalid-session-id',
  SESSION_NOT_FOUND = 'session-not-found',
  INVALID_FILE_TYPE = 'invalid-file-type',
  LOGO_UPLOAD_ERROR = 'logo-upload-error',
  ENTRA_ID_AUTH_ERROR = 'entra-id-auth-error',
  ENTRA_USERNAME_NOT_FOUND = 'username-not-found',
  ENTRA_USERNAME_AMBIGUOUS = 'username-ambiguous',
  DOMAIN_ALREADY_EXISTS = 'domain-already-exists',
  DIFFERENT_CUSTOMER = 'different-customer',
  DIRECTORIES_SYNC_ERROR = 'directory-sync-error',
  SECURITY_GROUPS_IDP_ERROR = 'idp-config-not-found',
  TOKEN_EXPIRED = 'token-expired',
  INVALID_LEGAL_DOCUMENT = 'invalid-legal-document',
  USERS_IMPORT_FAIL = 'users-import-fail',
  INVALID_ARGUMENT = 'invalid-argument',
  PASSWORD_REUSED = 'password-reused',
  INVALID_PASSWORD = 'invalid-password',
  ASSURANCE_IN_PROGRESS = 'assurance-in-progress', // for assurance/start
  APP_NOT_CONFIGURED = 'app-not-configured',
}

export const SESSION_ERROR_CODES = [
  ErrorCode.SESSION_EXPIRED,
  ErrorCode.INVALID_SESSION_ID,
  ErrorCode.SESSION_NOT_FOUND,
];
